import { Api } from '../api';
import { messages } from '../endpoints';
import type { ApiResponse, FileResponse } from '../../models';
import type {
  AddAttachmentsRequest,
  AddAttachmentsResponse,
  AddMessageRequest,
  AddMessageResponse,
  DownloadAttachmentRequest,
  ReadThreadsRequest,
  ReadThreadsResponse,
  RemoveAttachmentsRequest,
  ThreadsMessagesResponse,
  ThreadsResponse,
} from './models';

export class MessagesApi extends Api {
  static getThreads = (signal?: AbortSignal) => this.get<ApiResponse<ThreadsResponse[]>>({ url: messages.getThreads(), signal });

  static getThreadsMessages = (groupId: string, signal?: AbortSignal) =>
    this.get<ApiResponse<ThreadsMessagesResponse[]>>({ url: messages.getThreadsMessages(groupId), signal });

  static readThread = (request: ReadThreadsRequest, signal?: AbortSignal) =>
    this.put<ReadThreadsRequest, ApiResponse<ReadThreadsResponse>>({ url: messages.readThread(), data: request, signal });

  static deleteThread = (groupId: string, signal?: AbortSignal) => this.delete({ url: messages.deleteThread(groupId), signal });

  static addAttachments = ({ request, messageId }: AddAttachmentsRequest, signal?: AbortSignal) =>
    this.post<FormData, ApiResponse<AddAttachmentsResponse>>({ url: messages.addAttachments(messageId), data: request, signal });

  static addMessage = (request: AddMessageRequest, signal?: AbortSignal) =>
    this.post<AddMessageRequest, ApiResponse<AddMessageResponse>>({ url: messages.addMessage(), data: request, signal });

  static downloadAttachment = ({ fileId, messageId }: DownloadAttachmentRequest, signal?: AbortSignal) =>
    this.get<FileResponse>({ url: messages.downloadAttachment(fileId, messageId), signal });

  static removeAttachment = ({ fileId, messageId }: RemoveAttachmentsRequest, signal?: AbortSignal) =>
    this.delete({ url: messages.removeAttachment(fileId, messageId), signal });
}
